<template>
  <div class="salesOrder">
    <div slot="toolbar" class="toolbar-btn">
      <div
          class="chaxun"
          style="margin-bottom: 5px; display: flex; flex-direction: row; align-items: center; flex-wrap: wrap">
        <div style="width: 100%; border-bottom: 1px solid #cccccc; margin-bottom: 5px">

          <el-button
              style="background: none; border: none"
              icon="el-icon-files"
              @click="createYiXinApplication">
            发货通知
          </el-button>
        </div>
      </div>
    </div>
    <template>
      <div style="width: 100%; background: #f4f7fa; margin-top: 10px; margin-bottom: 10px">
        <div
            style="display: flex; flex-direction: row; justify-content: space-between; align-items: center; margin: 5px 0">
          <div>
            <el-button
                type="primary"
                class="adSearchShow"
                style="background: none; border: none; color: #2d8cf0"
                :icon="adSearchShow ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
                @click="adSearchShow = !adSearchShow">
              {{adSearchShow ? "收起" : "展开"}}
            </el-button>
          </div>
        </div>
        <div v-if="adSearchShow" class="sousuo">
          <div class="sousuo-nr">
            <vm-search label="合同号">
              <el-input
                  v-model.trim="filter.clientContractNos"
                  style="width: 150px"
                  clearable
                  type="textarea"
                  placeholder="多个精准搜索"/>
            </vm-search>
            <vm-search label="合同号">
              <el-input v-model.trim="filter.clientContractNo" style="width: 150px" clearable placeholder="单个模糊查询"/>
            </vm-search>
            <vm-search label="SAP订单号">
              <el-input
                  v-model.trim="filter.salesOrderNos"
                  style="width: 150px"
                  clearable
                  type="textarea"
                  placeholder="多个精准搜索"/>
            </vm-search>
            <vm-search label="SAP订单号">
              <el-input v-model.trim="filter.salesOrderNo" style="width: 150px" clearable placeholder="单个模糊查询"/>
            </vm-search>
          </div>
          <div class="ad-search-btn">
            <el-button
                :loading="loading"
                type="primary"
                size="mini"
                style="height: 26px; padding: 0 10px"
                @click="handleSearchClick">
              查询
            </el-button>
            <el-button
                plain
                type="primary"
                size="mini"
                style="height: 26px; padding: 0 10px"
                @click="handleClearClick">
              重置
            </el-button>
          </div>
        </div>
      </div>
    </template>
    <el-table
        v-loading="loading"
        :data="tableData"
        height="60vh"
        style="width: 100%"
        @select="selectOne"
        @select-all="selectAll">
      <el-table-column type="selection" align="center" width="55"/>
      <el-table-column
          prop="customerContractNo"
          align="center"
          label="项目名称"
          min-width="340"
          show-overflow-tooltip/>
      <el-table-column
          prop="customerName"
          align="center"
          label="客户"
          min-width="200"
          show-overflow-tooltip/>
      <el-table-column
          prop="salesName"
          align="center"
          width="120"
          label="创建者"
          show-overflow-tooltip/>
      <el-table-column prop="billNo" align="center" width="100" label="SAP订单号"/>
      <el-table-column
          prop="clientContractNO"
          align="center"
          label="客户合同号"
          width="240"
          show-overflow-tooltip/>
      <el-table-column prop="deliveryDate" align="center" width="90" label="计划交期"/>
      <el-table-column prop="totalAmount" align="center" width="90" label="总金额"/>
      <el-table-column prop="submitTime" align="center" width="135" label="提交时间"/>
      <el-table-column prop="status" align="center" width="100" label="状态">
        <template slot-scope="scope">
          {{constant.salesStatus[scope.row.status]}}
        </template>
      </el-table-column>
      <el-table-column prop="deliveryStatusName" align="center" width="70" label="发货状态"/>
      <div style="margin-top: 16px; overflow: hidden; color: #000">
        <el-pagination
            class="page"
            :page-sizes="[10, 50, 100, 200, 300, 500]"
            :page-size.sync="pageSize"
            :current-page="currentPage"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="changePage"/>
      </div>
      <sales-order-trace ref="traceSalesOrder" @save-success="getList(-1)"/>
      <select-file-dialog ref="selectFileDialog" @save_success="getList(-1)"/>
      <yi-xin-application-preview ref="yiXinApplicationDialog" @save-success="getList(-1)"/>
    </el-table>
    <div style="margin-top: 16px; overflow: hidden; color: #000">
      <el-pagination
          class="page"
          :page-sizes="[10, 50, 100, 200, 300, 500]"
          :page-size.sync="pageSize"
          :current-page="currentPage"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="changePage"/>
    </div>
  </div>
</template>

<script>
  import SalesOrderTrace from "@/views/salesManage/salesOrder/SalesOrderTrace";
  import VmSearch from "@/components/VmSearch";
  import loginUtil from "@/util/loginUtil";
  import constant from "@/util/constant";
  import SelectFileDialog from "@/views/salesManage/salesOrder/SelectFileDialog";
  import YiXinApplicationPreview from "@/views/salesManage/yiXinShipmentApplication/yiXinApplicationEdit";

  export default {
    name: "ToDoYiXinApplication",
    components: {VmSearch, SalesOrderTrace, SelectFileDialog,YiXinApplicationPreview},
    data() {
      return {
        constant,
        submitDate: [],
        editAuth: this.$auth(179),
        exportExcelLoading: false,
        KrTKEImportLoading: false,
        IndTKEImportLoading: false,
        priceImportLoading: false,
        yiXinApplicationDialog:false,
        DsExportVisible: false,
        SelectFileDialog: false,
        exportLoading: false,
        isBtn: true,
        isBtn1: false,
        adSearchShow: true,
        loading: false,
        fileList: [],
        pickerOptions: {
          disabledDate: (time) => {
            return this.dealDisabledDate(time);
          },
        },
        idList: "",
        filter: {
          filter: "",
          clientContractNo:"",
          clientContractNos:"",
          salesOrderNo:"",
          salesOrderNos:"",
        },
        currentPage: 1,
        pageSize: 10,
        total: 0,
        params: {
          unpaidTaxtMoney: "",
          taxIncludedMoney: "",
          strDate: "",
          editDate: "",
        },
        tableData: [],
        ids: [],
        selection: [],
        ruleValidate: {},
      };
    },
    computed: {
      buttonStyle: function() {
        return {
          color: this.isBtn ? "#2D8CF0" : "#000",
          background: "none",
          border: "none",
        };
      },
      buttonStyle1: function() {
        return {
          color: this.isBtn1 ? "#2D8CF0" : "#000",
          background: "none",
          border: "none",
        };
      },
    },
    mounted() {
      this.initTime();
    },
    methods: {
      getList(pageIndex) {
        if (
          this.filter.beginSubmitTime !== null &&
          this.filter.endSubmitTime !== null &&
          this.filter.endSubmitTime !== "" &&
          this.filter.beginSubmitTime !== ""
        ) {
          if (this.dateCompare(this.filter.endSubmitTime, this.filter.beginSubmitTime)) {
            return this.$message.error("提交开始日期不能大于提交结束日期");
          }
        }
        this.currentPage = pageIndex;
        this.loading = true;
        let params = Object.assign({pageSize: this.pageSize, pageNum: pageIndex}, this.filter);
        this.$http
          .get("basic", "YiXinShipmentApplication/toDoPurchasePage", params)
          .then((res) => {
            this.loading = false;
            this.tableData = res.records;
            this.total = res.total;
          })
          .catch(() => {
            this.loading = false;
            this.$message.error("获取失败");
          });
      },

      renderHeader(h, {column}) {
        return h("span", [
          h("span", column.label),
          h("i", {
            class: "el-icon-paperclip",
            style: "color:#444444; font-size: 16px;",
          }),
        ]);
      },
      handleSearchClick() {
        this.getList(1);
      },
      handleClearClick() {
        this.filter.filter = "";
        this.filter.salesOrderNO = "";
        this.filter.sAPSalesOrderNO = "";
        this.filter.customerName = "";
        this.filter.clientContractNO = "";
        this.filter.projectName = "";
        this.filter.creatorName = "";
        this.filter.status = "";
        this.filter.beginSubmitTime = "";
        this.filter.endSubmitTime = "";
        this.filter.priority = "";
        this.filter.includeControlBox = "";
        this.filter.keyMaterial = "";
        this.filter.timeSegment = 2020;
        this.isBtn = true;
        this.isBtn1 = false;
        this.$nextTick(() => {
          this.getList(1);
        });
      },
      onProgress() {
        this.BatchTimeLoading = true;
        this.disabled = true;
      },

      handleRemove(file, fileList) {
        console.log(file, fileList);
      },

      fileChange(file, fileList) {
        this.fileList = fileList;
      },

      dialogClose() {
        this.$refs.form.resetFields();
        this.submitLoading = false;
      },

      changePage(pageIndex) {
        this.getList(pageIndex);
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.getList(1);
      },






      handleChange() {
        this.getList(1);
      },
      selectOne(selection) {
        this.ids = [];
        this.selection = [];
        this.selection = selection;
        for (let item of selection) {
          this.ids.push(item.pkid);
        }
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
        this.selection = selection;
      },

      //导出
      exportExcel(dataType) {
        let url = "";
        if (dataType === 1) {
          url = "sd/so/exportTechParamBill";
        } else if (dataType === 2) {
          url = "sd/so/exportProductionDetail";
        }
        this.exportExcelLoading = true;
        this.$http
          .exportFile("basic", url, this.filter)
          .then((res) => {
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportExcelLoading = false;
          })
          .catch(() => {
            this.exportExcelLoading = false;
          });
      },


      SelectFileClick() {
        this.$refs.selectFileDialog.open();
      },


      goto(row) {
        this.$router.push({
          path: "/salesOrder",
          query: {
            billType: 1,
            billId: row.pkid,
            $tabName: row.salesOrderNO,
          },
        });
      },
      initTime() {
        this.filter.endSubmitTime = this.getFormatDate(new Date());
        this.filter.beginSubmitTime = this.getFormatDate(new Date(new Date() - 3600 * 1000 * 24 * 29));
        // this.submitDate = [];
        // this.submitDate.push(this.filter.beginSubmitTime);
        // this.submitDate.push(this.filter.endSubmitTime);
        this.getList(1);
      },
      // 获取当前时间
      getFormatDate(date) {
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        return date.getFullYear() + "-" + month + "-" + strDate;
      },
      dealDisabledDate(time) {
        if (this.isBtn) {
          return time.getTime() < new Date("2019-12-31").getTime();
        } else {
          return time.getTime() > new Date("2019-12-31").getTime();
        }
      },
      newTime() {
        this.isBtn1 = false;
        this.isBtn = !this.isBtn;
        this.filter.timeSegment = 2020;
        this.filter.endSubmitTime = this.getFormatDate(new Date());
        this.filter.beginSubmitTime = this.getFormatDate(new Date(new Date() - 3600 * 1000 * 24 * 29));
      },
      oldTime() {
        this.isBtn = false;
        this.isBtn1 = !this.isBtn1;
        this.filter.timeSegment = 2019;
        this.filter.beginSubmitTime = "2019-01-01";
        this.filter.endSubmitTime = "2019-12-31";
        // this.submitDate = [];
        // this.submitDate.push(this.filter.beginSubmitTime);
        // this.submitDate.push(this.filter.endSubmitTime);
        // this.getList(1);
      },
      dateCompare(date1, date2) {
        let time1 = date1.replace(/-/g, "");
        let time2 = date2.replace(/-/g, "");
        if (time1 <= time2) {
          return true;
        } else {
          return false;
        }
      },

      createYiXinApplication() {
        let flag = true;
        if (!this.selection.length) {
          this.$confirm("请选择销售订单", "错误", {
            type: "error",
            showCancelButton: false,

          });
          flag = false;
        }

        if (flag) {
          this.$refs.yiXinApplicationDialog.openByWaiCai(this.selection);
        }

      },
    },
  };
</script>

<style lang="scss" scoped>
.salesOrder {
  .vm-page-table .ad-search .ad-search_content .ad-search-btn {
    height: 28px;
  }

  .el-select {
    width: 150px !important;
  }

  .el-radio__label {
    font-size: 12px !important;
  }

  .el-radio {
    margin-right: 5px !important;
  }

  .el-radio__label {
    padding-right: 5px !important;
    padding-left: 5px !important;
  }

  .vm-page-table .ad-search .ad-search_content {
    padding: 0 !important;
    width: 100%;
  }

  .vm-page-table .ad-search .ad-search_content .ad-search-btn {
    bottom: 2px;
  }

  .el-pagination {
    text-align: right;
  }

  .sousuo {
    width: 100%;
    background: #f4f7fa;
    /*margin-top: 10px;*/
    margin-bottom: 10px;
    border-top: 1px dashed #cccccc;

    .sousuo-nr {
      padding: 10px 10px 8px 10px;

      .vm-search-com .vm-search-label[data-v-658ba3ef] {
        width: 80px !important;
        font-size: 12px !important;
      }

      .zhi {
        width: 180px !important;
      }
    }

    .ad-search-btn {
      text-align: left;
      margin: 10px 0 0 20px;
      padding-bottom: 5px;
    }
  }

  .date-display {
    display: inline-block;
  }

  .radiobg {
    background: #eaf4fe;
    padding: 5px;
    border: 1px solid #e6e6e6;
    font-size: 12px !important;

    .el-radio__label {
      font-size: 12px !important
    }
  }
}
</style>
